<template>
  <div class="number-title" flex="main:top" :class="[isEmpty(position) ? '' : 'absolute-el']" :style="{ ...position, ...customStyle }">
    <div class="icon"></div>
    <PftDataText
      ref="dataRef"
      :title="title"
      :titleStyle="{
        color: '#fff',
        fontSize: '14px',
      }"
      :dataStyle="{
        color: '#FCF072FF',
        fontSize: '32px',
        fontWeight: 'bold',
        textShadow: '0px 0px 6px #D07D1C',
        fontStyle: 'italic',
        ...customStyle,
      }"
      :storeData="storeData"
    ></PftDataText>
  </div>
</template>

<script setup lang="ts">
import { isEmpty } from "lodash-es"
import PftDataText from "@p-v/packages/DataText.vue"
import { onMounted, ref, watch } from "vue"

interface NumberTitleProps {
  title: string
  storeData: string | number
  customStyle?: any
  position?: any
}

const props = withDefaults(defineProps<NumberTitleProps>(), {
  title: "标题",
  storeData: 0,
})

const dataRef = ref<InstanceType<typeof PftDataText> | null>(null)

const refreshData = (storeData: any) => {
  if (typeof storeData === "string" || typeof storeData === "number") {
    dataRef.value?.setData(storeData as string)
  } else {
    dataRef.value?.setData(storeData.value)
  }
}

watch(
  () => props.storeData,
  newValue => {
    refreshData(newValue)
  },
  {
    immediate: true,
    deep: true,
  },
)

onMounted(() => {
  refreshData(props.storeData)
})
</script>

<style lang="scss">
.number-title {
  .icon {
    width: 48px;
    height: 48px;
    flex-shrink: 0;
    background-image: url("@p-v/packages/Decorate/NumberTitle/flipper_icon_pre.png");
    background-size: cover;
    background-position: center;
    margin-right: 12px;
  }
}
</style>
